export enum UserRoles {
    INFLUENCER = 'influencer',
    BRAND = 'brand',
    BRAND_MASTER = 'brand_master',
    AGENCY = 'agency',
    AGENCY_MASTER = 'agency_master',
}
